import {Component, Plugins, EvalEnv} from '@packages/systems/wfdl';
import {Qualified, qualify, namesEqual} from '@packages/systems/wfdl-Qualified';
import {localesListItemVariable} from '@packages/shared/constants/Render';
import {Env} from '../Env';

const localesItemType = qualify(
  Plugins.name('Localization'),
  Component.name('LocalesItem')
);

export const updateEnvForLocalizationLocalesItem = (
  elType: Qualified<Component.ComponentName>,
  env: Env
) => {
  if (namesEqual(elType, localesItemType)) {
    const locale = env.pluginsContext.get('Localization')?.get('locale');

    if (!locale) return env;

    const evalEnv = EvalEnv.insertValue(
      env.evalEnv,
      localesListItemVariable,
      locale
    );

    if (!locale.pageHref || !locale.pageId) return {...env, evalEnv};

    const sharedContext = env.sharedContext.update(
      'hrefMap',
      (original = {}) => {
        return {
          ...original,
          [locale.pageId]: locale.pageHref,
        };
      }
    );

    return {...env, evalEnv, sharedContext};
  }

  return env;
};
